import React, { useState, useEffect, useMemo } from 'react';
import { compose } from 'recompose';
import styled from 'styled-components';
import { hot } from 'react-hot-loader';
import { Link, useHistory } from 'react-router-dom';
import ReactDatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

import {
  Card,
  Header,
  Dimmer,
  Loader,
  Breadcrumb,
  Form,
  Button,
  Icon,
  Select,
  Input,
  TextArea,
  Message,
  Segment,
  Table,
  Modal,
  Checkbox
} from 'semantic-ui-react';

import getDateTimeString from 'op/utils/getDateTimeString';
import { withReportSignatures } from 'op/components/report/signature/report-signature.helper';
import SignatureModal from 'op/components/report/signature/signature-modal/signature-modal.component';
import { TreeDropdown } from 'op/components/tree-dropdown';

var CardForSignature = styled(Card)`
  img {
    max-width: 100% !important;
    width: 100% !important;
  }
`;

var FileUploadContainer = styled.div`
  margin-bottom: 1em;

  .file-input-wrapper {
    display: flex;
    align-items: center;
    gap: 0.75em;
    margin-top: 0.5em;
    flex-wrap: wrap;
  }

  .file-name {
    color: #444;
    font-size: 0.9em;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .file-name-placeholder {
    color: #999;
    font-size: 0.9em;
  }
`;

var NonResizableTextArea = styled(TextArea)`
  resize: none !important;
`;

var CreateAuditButton = styled(Button)`
  width: 100% !important;
  padding: 1em !important;
  font-size: 1.1em !important;
  margin-top: 1em !important;
`;

var Thing = styled.div`
  display: flex;
  justify-content: space-between;
`;

var EvalContainer = styled.div`
  display: flex;
`;

var EvalButtonsContainer = styled.div`
  display: flex;
  border-radius: 5px;
  overflow: hidden;
  margin: 0 10px;
`;

var EvalButton = styled.button`
  height: 3em;
  border: none;
  flex: ${props => props.fluid ? 1 : 0};
  border-radius: ${props => props.rounded ? '5px' : 'none'};
  color: ${props => props.selected ? (props.theme && props.theme.white) || '#fff' : (props.theme && props.theme.text) || '#333'};
  background-color: ${props => props.selected ? (props.theme && props.theme.dark) || '#4a4a4a' : (props.theme && props.theme.white) || '#fff'};
  outline: none !important;
  margin: 0 1.5px;
  cursor: pointer;
`;

var AuditFormComponent = function(props) {
  var locale = props.locale;
  var loading = props.loading;
  var unitTree = props.unitTree;
  var mainCategories = props.mainCategories;
  var subCategories = props.subCategories;
  var fetchSubCategories = props.fetchSubCategories;
  var saving = props.saving;
  var form = props.form;
  var setForm = props.setForm;
  var report = props.report;
  var registerSignatrue = props.registerSignatrue;
  var saveSignatrues = props.saveSignatrues;
  var onCreateAudit = props.onCreateAudit;
  var onSubmit = props.onSubmit;
  var auditCreated = props.auditCreated;
  var isKPIMng = props.isKPIMng;
  var kpiTypes = props.kpiTypes;
  var kpiData = props.kpiData;
  var kpiNames = props.kpiNames;
  var selectedMainCategory = props.selectedMainCategory;
  var setSelectedMainCategory = props.setSelectedMainCategory;
  var onKpiExecutionChange = props.onKpiExecutionChange;
  var onKpiFieldChange = props.onKpiFieldChange;
  var onBackClick = props.onBackClick;
  var mainStatuses = props.mainStatuses;
  var selectedStatusId = props.selectedStatusId;
  var setSelectedStatusId = props.setSelectedStatusId;
  var statusRemarks = props.statusRemarks;
  var setStatusRemarks = props.setStatusRemarks;
  var isEmployeeMng = props.isEmployeeMng;
  var unitPersons = props.unitPersons;
  var auditPersons = props.auditPersons;
  var employeesModalOpen = props.employeesModalOpen;
  var setEmployeesModalOpen = props.setEmployeesModalOpen;
  var onOpenEmployeesModal = props.onOpenEmployeesModal;
  var onAddAuditPerson = props.onAddAuditPerson;
  var onDeleteAuditPerson = props.onDeleteAuditPerson;
  var followupTypes = props.followupTypes || [];
  var isFollowupMng = props.isFollowupMng || false;
  var auditFollowups = props.auditFollowups || [];
  var onAddFollowup = props.onAddFollowup;
  var onDeleteFollowup = props.onDeleteFollowup;
  var trainingEventTypes = props.trainingEventTypes || [];
  var trainingEventCategories = props.trainingEventCategories || [];
  var onPersonTaskTypeChange = props.onPersonTaskTypeChange;

  var history = useHistory();

  var employeeSearchState = useState('');
  var employeeSearch = employeeSearchState[0];
  var setEmployeeSearch = employeeSearchState[1];

  var expandedPersonState = useState(null);
  var expandedPerson = expandedPersonState[0];
  var setExpandedPerson = expandedPersonState[1];

  var personFormState = useState({ taskTypeId: null, taskCategoryId: null, followupAlert: false, followupRemarks: '', followupResultDate: null });
  var personForm = personFormState[0];
  var setPersonForm = personFormState[1];

  var followupFormVisibleState = useState(false);
  var followupFormVisible = followupFormVisibleState[0];
  var setFollowupFormVisible = followupFormVisibleState[1];

  var newFollowupState = useState({ followupTypeId: null, startDate: null, endDate: null, remarks: '' });
  var newFollowup = newFollowupState[0];
  var setNewFollowup = newFollowupState[1];

  var descriptionModalState = useState({ open: false, title: '', description: '' });
  var descriptionModal = descriptionModalState[0];
  var setDescriptionModal = descriptionModalState[1];

  var remarksModalState = useState({ open: false, kpiTypeId: null, value: '' });
  var remarksModal = remarksModalState[0];
  var setRemarksModal = remarksModalState[1];

  var followupModalState = useState({ open: false, kpiTypeId: null, value: '' });
  var followupModal = followupModalState[0];
  var setFollowupModal = followupModalState[1];

  var followupResultModalState = useState({ open: false, kpiTypeId: null, value: '' });
  var followupResultModal = followupResultModalState[0];
  var setFollowupResultModal = followupResultModalState[1];

  useEffect(function() {
    if (selectedMainCategory) {
      fetchSubCategories(selectedMainCategory);
      setForm(function(prev) { return Object.assign({}, prev, { INS_SubCategoryID: null }); });
    }
  }, [selectedMainCategory]);

  var fileInputRef1 = React.useRef(null);
  var fileInputRef2 = React.useRef(null);
  var fileInputRef3 = React.useRef(null);

  var fileInputRefs = [null, fileInputRef1, fileInputRef2, fileInputRef3];

  var handleFileUpload = function(e, uploadNumber) {
    var file = e.target.files[0];
    if (file) {
      var reader = new FileReader();
      reader.onload = function(event) {
        var base64 = event.target.result.split(',')[1];
        setForm(function(prev) {
          var update = {};
          update['INS_MainAuditUpload' + uploadNumber] = base64;
          update['INS_MainAuditUploadFilename' + uploadNumber] = file.name;
          return Object.assign({}, prev, update);
        });
      };
      reader.readAsDataURL(file);
    }
  };

  var handleFileClear = function(uploadNumber) {
    setForm(function(prev) {
      var update = {};
      update['INS_MainAuditUpload' + uploadNumber] = null;
      update['INS_MainAuditUploadFilename' + uploadNumber] = null;
      return Object.assign({}, prev, update);
    });
    var ref = fileInputRefs[uploadNumber];
    if (ref && ref.current) ref.current.value = '';
  };

  var validation = useMemo(function() {
    var messages = [];
    if (!form.RDS_Unit_ID) messages.push(locale.validation.unitRequired);
    if (!form.INS_SubCategoryID) messages.push(locale.validation.auditSubjectRequired);
    if (!form.INS_MainAuditDate) messages.push(locale.validation.auditDateRequired);
    if (!form.INS_MainAuditUserName) messages.push(locale.validation.auditorNameRequired);

    return {
      ok: messages.length === 0,
      messages: messages
    };
  }, [form]);

  var handleCreateAudit = function() {
    if (!validation.ok) return;
    onCreateAudit();
  };

  var handleSubmit = function() {
    onSubmit();
  };

  if (loading) {
    return (
      <Card fluid>
        <Card.Content>
          <Dimmer active><Loader content={locale.messages.loading} /></Dimmer>
        </Card.Content>
      </Card>
    );
  }

  var handleUnitChange = function(unitId, unitName) {
    setForm(function(prev) { return Object.assign({}, prev, { RDS_Unit_ID: unitId }); });
  };

  var mainCategoryOptions = mainCategories.map(function(c) {
    return {
      key: c.inS_MainCategoryID,
      value: c.inS_MainCategoryID,
      text: c.inS_MainCategoryName
    };
  });

  var subCategoryOptions = subCategories
    .filter(function(sc) { return !selectedMainCategory || sc.inS_MainCategoryID === selectedMainCategory; })
    .map(function(sc) {
      return {
        key: sc.inS_SubCategoryID,
        value: sc.inS_SubCategoryID,
        text: sc.inS_SubCategoryName
      };
    });

  var statusOptions = (mainStatuses || []).map(function(s) {
    return {
      key: s.inS_MainStatusID || s.INS_MainStatusID,
      value: s.inS_MainStatusID || s.INS_MainStatusID,
      text: s.inS_MainStatusName || s.INS_MainStatusName
    };
  });

  var openDescriptionModal = function(title, description) {
    setDescriptionModal({ open: true, title: title, description: description });
  };

  var openRemarksModal = function(kpiTypeId) {
    var kpi = kpiData.find(function(k) { return k.INS_KPITypeID === kpiTypeId; });
    setRemarksModal({ open: true, kpiTypeId: kpiTypeId, value: kpi ? kpi.INS_MainAuditKPIRemarks : '' });
  };

  var saveRemarks = function() {
    onKpiFieldChange(remarksModal.kpiTypeId, 'INS_MainAuditKPIRemarks', remarksModal.value);
    setRemarksModal({ open: false, kpiTypeId: null, value: '' });
  };

  var openFollowupModal = function(kpiTypeId) {
    var kpi = kpiData.find(function(k) { return k.INS_KPITypeID === kpiTypeId; });
    setFollowupModal({ open: true, kpiTypeId: kpiTypeId, value: kpi ? kpi.INS_MainAuditKPIFollowup : '' });
  };

  var saveFollowup = function() {
    onKpiFieldChange(followupModal.kpiTypeId, 'INS_MainAuditKPIFollowup', followupModal.value);
    setFollowupModal({ open: false, kpiTypeId: null, value: '' });
  };

  var openFollowupResultModal = function(kpiTypeId) {
    var kpi = kpiData.find(function(k) { return k.INS_KPITypeID === kpiTypeId; });
    setFollowupResultModal({ open: true, kpiTypeId: kpiTypeId, value: kpi ? kpi.INS_MainAuditKPIFollowupResult : '' });
  };

  var saveFollowupResult = function() {
    onKpiFieldChange(followupResultModal.kpiTypeId, 'INS_MainAuditKPIFollowupResult', followupResultModal.value);
    setFollowupResultModal({ open: false, kpiTypeId: null, value: '' });
  };

  var renderKpiSection = function() {
    if (!isKPIMng || kpiData.length === 0) return null;

    return (
      <Segment>
        <Header as='h3'>{locale.headers.kpi}</Header>
        <div style={{ overflowX: 'auto' }}>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>{locale.headers.kpi}</Table.HeaderCell>
              <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>{locale.labels.executionLevel}</Table.HeaderCell>
              <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>{locale.labels.followupAlert}</Table.HeaderCell>
              <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>{locale.labels.followup}</Table.HeaderCell>
              <Table.HeaderCell style={{ whiteSpace: 'nowrap', width: '15%' }}>{locale.labels.followupDate}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {kpiData.map(function(kpi) {
              return (
                <Table.Row key={kpi.INS_KPITypeID}>
                  <Table.Cell style={{ width: '45%' }}>
                    <Thing>
                      <div>
                        {(kpi.kpiTypeName || '').split('\n').map(function(l, k) {
                          return <span key={k}>{l}<br /></span>;
                        })}
                      </div>
                      <Icon
                        className="kpi-icon"
                        name={kpi.INS_MainAuditKPIRemarks ? 'info circle' : 'edit'}
                        style={{ margin: 'auto 10px auto 0' }}
                        onClick={function() { openRemarksModal(kpi.INS_KPITypeID); }}
                      />
                    </Thing>
                    <Thing>
                      <Icon
                        className="kpi-icon"
                        name="question circle outline"
                        style={{ margin: 'auto 10px auto 0' }}
                        onClick={function() { openDescriptionModal(locale.modals.description.title, kpi.kpiTypeDescription); }}
                      />
                    </Thing>
                  </Table.Cell>
                  <Table.Cell style={{ width: '20%' }}>
                    <EvalContainer>
                      <EvalButtonsContainer>
                        {kpiNames.map(function(kpiName) {
                          var isSelected = kpi.INS_MainCategoryKPI === kpiName.index;
                          return (
                            <EvalButton
                              key={kpiName.index}
                              type="button"
                              selected={isSelected}
                              onClick={function() { onKpiExecutionChange(kpi.INS_KPITypeID, kpiName.index); }}
                            >
                              {kpiName.name}
                            </EvalButton>
                          );
                        })}
                      </EvalButtonsContainer>
                    </EvalContainer>
                  </Table.Cell>
                  <Table.Cell textAlign='center' style={{ width: '7%' }}>
                    <Checkbox
                      checked={kpi.INS_MainAuditKPIFollowupAlert || false}
                      onChange={function(e, data) {
                        onKpiFieldChange(kpi.INS_KPITypeID, 'INS_MainAuditKPIFollowupAlert', data.checked);
                      }}
                    />
                  </Table.Cell>
                  <Table.Cell textAlign="center" style={{ width: '7%' }}>
                    <Icon
                      className="kpi-icon"
                      name="edit"
                      style={{ margin: '0 auto', cursor: 'pointer' }}
                      color={kpi.INS_MainAuditKPIFollowup ? 'blue' : 'grey'}
                      onClick={function() { openFollowupModal(kpi.INS_KPITypeID); }}
                    />
                  </Table.Cell>
                  <Table.Cell>
                    <ReactDatePicker
                      selected={kpi.INS_MainAuditKPIFollowupDate ? (kpi.INS_MainAuditKPIFollowupDate instanceof Date ? kpi.INS_MainAuditKPIFollowupDate : new Date(kpi.INS_MainAuditKPIFollowupDate)) : null}
                      onChange={function(date) { onKpiFieldChange(kpi.INS_KPITypeID, 'INS_MainAuditKPIFollowupDate', date); }}
                      dateFormat="dd/MM/yyyy"
                      isClearable
                      placeholderText={locale.placeholders.selectDate}
                    />
                  </Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
        </div>
      </Segment>
    );
  };

  return (
    <Card.Group>
      <Card fluid>
        <Card.Content>
          <button type="button" onClick={function() { (onBackClick || function() { history.goBack(); })(); }}>
            <Icon name="arrow left" />
          </button>
          <Card.Header>
            <Breadcrumb>
              <Breadcrumb.Section link as={Link} to="/audit">{locale.breadcrumb.audits}</Breadcrumb.Section>
              <Breadcrumb.Divider />
              <Breadcrumb.Section active>{locale.breadcrumb.newAudit}</Breadcrumb.Section>
            </Breadcrumb>
          </Card.Header>

          <Form error={!validation.ok && !auditCreated}>
            <Segment>
              <Header as='h3'>{locale.headers.generalInformation}</Header>

              <Form.Field required>
                  <label>{locale.labels.auditDate}</label>
                  <ReactDatePicker
                    selected={form.INS_MainAuditDate}
                    onChange={function(date) { setForm(function(prev) { return Object.assign({}, prev, { INS_MainAuditDate: date }); }); }}
                    showTimeSelect
                    dateFormat="dd/MM/yyyy HH:mm"
                    timeFormat="HH:mm"
                    disabled={auditCreated}
                  />
                </Form.Field>

              <Form.Group widths='equal'>
                <Form.Field required>
                  <label>{locale.labels.unitName}</label>
                  <TreeDropdown
                    items={unitTree}
                    value={form.RDS_Unit_ID}
                    onChange={handleUnitChange}
                    placeholder={locale.placeholders.selectUnit}
                    loading={loading}
                    disabled={auditCreated}
                  />
                </Form.Field>

                <Form.Field>
                  <label>{locale.labels.auditAreaName}</label>
                  <Select
                    placeholder={locale.placeholders.selectAuditArea}
                    options={mainCategoryOptions}
                    value={selectedMainCategory}
                    onChange={function(e, data) { setSelectedMainCategory(data.value); }}
                    search
                    clearable
                    disabled={auditCreated}
                  />
                </Form.Field>

                <Form.Field required>
                  <label>{locale.labels.auditSubjectName}</label>
                  <Select
                    placeholder={locale.placeholders.selectAuditSubject}
                    options={subCategoryOptions}
                    value={form.INS_SubCategoryID}
                    onChange={function(e, data) { setForm(function(prev) { return Object.assign({}, prev, { INS_SubCategoryID: data.value }); }); }}
                    search
                    disabled={auditCreated}
                  />
                </Form.Field>
              </Form.Group>

              <Form.Group widths='equal'>
                
                <Form.Field>
                  <label>{locale.labels.followupManager}</label>
                  <Input
                    value={form.INS_MainAuditFollowupManagerName}
                    onChange={function(e, data) { setForm(function(prev) { return Object.assign({}, prev, { INS_MainAuditFollowupManagerName: data.value }); }); }}
                    disabled={auditCreated}
                  />
                </Form.Field>

                <Form.Field required>
                  <label>{locale.labels.auditorName}</label>
                  <Input
                    value={form.INS_MainAuditUserName}
                    onChange={function(e, data) { setForm(function(prev) { return Object.assign({}, prev, { INS_MainAuditUserName: data.value }); }); }}
                    disabled={auditCreated}
                  />
                </Form.Field>

                <Form.Field>
                  <label>{locale.labels.unitManager}</label>
                  <Input
                    value={form.INS_MainAuditManagerName}
                    onChange={function(e, data) { setForm(function(prev) { return Object.assign({}, prev, { INS_MainAuditManagerName: data.value }); }); }}
                    disabled={auditCreated}
                  />
                </Form.Field>
              </Form.Group>

              <Form.Group widths='equal'>
                <Form.Field>
                  <label>{locale.labels.location}</label>
                  <Input
                    value={form.INS_MainAuditLocation}
                    onChange={function(e, data) { setForm(function(prev) { return Object.assign({}, prev, { INS_MainAuditLocation: data.value }); }); }}
                    disabled={auditCreated}
                  />
                </Form.Field>

                <Form.Field>
                  <label>{locale.labels.subLocation}</label>
                  <Input
                    value={form.INS_MainAuditSubLocation}
                    onChange={function(e, data) { setForm(function(prev) { return Object.assign({}, prev, { INS_MainAuditSubLocation: data.value }); }); }}
                    disabled={auditCreated}
                  />
                </Form.Field>

                <Form.Field>
                  <label>{locale.labels.auditStatusType}</label>
                  <Select
                    placeholder={locale.placeholders.selectStatusType}
                    options={statusOptions}
                    value={selectedStatusId}
                    onChange={function(e, data) { setSelectedStatusId(data.value); }}
                    search
                    clearable
                    disabled={auditCreated}
                  />
                </Form.Field>
              </Form.Group>
            </Segment>

            {!auditCreated && (
              <React.Fragment>
                <Message
                  error
                  header={locale.validation.header}
                  list={validation.messages}
                />

                <CreateAuditButton
                  primary
                  onClick={handleCreateAudit}
                  disabled={!validation.ok || saving}
                  loading={saving}
                >
                  {locale.buttons.createAudit}
                </CreateAuditButton>
              </React.Fragment>
            )}

            {auditCreated && (
              <React.Fragment>

                {renderKpiSection()}

                <Segment>
                  <Header as='h3'>{locale.headers.commentsFollowup}</Header>

                  <Form.Field>
                    <label>{locale.labels.generalRemarks}</label>
                    <NonResizableTextArea
                      value={form.INS_MainAuditGeneralComments}
                      onChange={function(e, data) { setForm(function(prev) { return Object.assign({}, prev, { INS_MainAuditGeneralComments: data.value }); }); }}
                      rows={3}
                    />
                  </Form.Field>

                  <Form.Field>
                    <label>{locale.labels.followupActionItems}</label>
                    <NonResizableTextArea
                      value={form.INS_MainAuditGeneralFollowup}
                      onChange={function(e, data) { setForm(function(prev) { return Object.assign({}, prev, { INS_MainAuditGeneralFollowup: data.value }); }); }}
                      rows={3}
                    />
                  </Form.Field>

                  <Form.Field>
                    <label>{locale.labels.completionTargetDate}</label>
                    <ReactDatePicker
                      selected={form.INS_MainAuditGeneralFollowupDate}
                      onChange={function(date) { setForm(function(prev) { return Object.assign({}, prev, { INS_MainAuditGeneralFollowupDate: date }); }); }}
                      showTimeSelect
                      dateFormat="dd/MM/yyyy HH:mm"
                      timeFormat="HH:mm"
                      isClearable
                      placeholderText={locale.placeholders.selectDate}
                    />
                  </Form.Field>
                </Segment>

                

                {isEmployeeMng && (
                  <Segment>
                    <Header as='h3'>{locale.headers.employees}</Header>
                    <Button
                      type="button"
                      primary
                      onClick={onOpenEmployeesModal}
                    >
                      <Icon name='users' /> {locale.buttons.employees}
                    </Button>
                    {auditPersons.length > 0 && (
                      <div style={{ marginTop: '1em' }}>
                        <p>{auditPersons.length} {locale.messages.employeesAdded}</p>
                      </div>
                    )}
                  </Segment>
                )}

                {isFollowupMng && (
                  <Segment>
                    <Header as='h3'>{locale.headers.auditFollowups}</Header>
                    <Button
                      type="button"
                      primary
                      onClick={function() { setFollowupFormVisible(true); setNewFollowup({ followupTypeId: null, startDate: null, endDate: null, remarks: '', alert: false }); }}
                      disabled={followupFormVisible}
                    >
                      <Icon name='plus' /> {locale.buttons.addFollowup}
                    </Button>

                    {followupFormVisible && (
                      <Segment style={{ marginTop: '1em' }}>
                        <Form>
                          <Form.Field>
                            <label>{locale.labels.actionItem}</label>
                            <Select
                              placeholder={locale.placeholders.selectActionItem}
                              options={followupTypes.map(function(ft) {
                                return {
                                  key: ft.inS_FollowupTypeID || ft.INS_FollowupTypeID,
                                  value: ft.inS_FollowupTypeID || ft.INS_FollowupTypeID,
                                  text: ft.inS_FollowupTypeName || ft.INS_FollowupTypeName
                                };
                              })}
                              value={newFollowup.followupTypeId}
                              onChange={function(e, data) { setNewFollowup(function(prev) { return Object.assign({}, prev, { followupTypeId: data.value }); }); }}
                              clearable
                            />
                          </Form.Field>
                          <Form.Group widths='equal'>
                            <Form.Field>
                              <label>{locale.labels.startDate}</label>
                              <ReactDatePicker
                                selected={newFollowup.startDate}
                                onChange={function(date) { setNewFollowup(function(prev) { return Object.assign({}, prev, { startDate: date }); }); }}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                                placeholderText={locale.placeholders.selectStartDate}
                              />
                            </Form.Field>
                            <Form.Field>
                              <label>{locale.labels.endDate}</label>
                              <ReactDatePicker
                                selected={newFollowup.endDate}
                                onChange={function(date) { setNewFollowup(function(prev) { return Object.assign({}, prev, { endDate: date }); }); }}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                                placeholderText={locale.placeholders.selectEndDate}
                              />
                            </Form.Field>
                          </Form.Group>
                          <Form.Field>
                            <label>{locale.labels.remarks}</label>
                            <TextArea
                              value={newFollowup.remarks}
                              onChange={function(e, data) { setNewFollowup(function(prev) { return Object.assign({}, prev, { remarks: data.value }); }); }}
                              rows={3}
                              placeholder={locale.placeholders.enterRemarks}
                            />
                          </Form.Field>
                          <Form.Field>
                            <label>{locale.labels.alert}</label>
                            <Checkbox
                              checked={newFollowup.alert || false}
                              onChange={function(e, data) { setNewFollowup(function(prev) { return Object.assign({}, prev, { alert: data.checked }); }); }}
                            />
                          </Form.Field>
                          <Button
                            primary
                            size='small'
                            type="button"
                            onClick={function() {
                              onAddFollowup({
                                INS_MainAuditID: 0,
                                INS_FollowupTypeID: newFollowup.followupTypeId || null,
                                INS_MainAuditFollowupsStartDate: newFollowup.startDate ? getDateTimeString(newFollowup.startDate) : null,
                                INS_MainAuditFollowupsEndDate: newFollowup.endDate ? getDateTimeString(newFollowup.endDate) : null,
                                INS_MainAuditFollowupsRemarks: newFollowup.remarks || null,
                                INS_MainAuditFollowupsAlert: newFollowup.alert || false,
                              });
                              setFollowupFormVisible(false);
                              setNewFollowup({ followupTypeId: null, startDate: null, endDate: null, remarks: '', alert: false });
                            }}
                          >
                            <Icon name='check' /> {locale.buttons.add}
                          </Button>
                          <Button
                            size='small'
                            type="button"
                            onClick={function() { setFollowupFormVisible(false); }}
                          >
                            {locale._system.cancel}
                          </Button>
                        </Form>
                      </Segment>
                    )}

                    {auditFollowups.length > 0 && (
                      <Table celled style={{ marginTop: '1em' }}>
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell>{locale.labels.actionItem}</Table.HeaderCell>
                            <Table.HeaderCell>{locale.labels.startDate}</Table.HeaderCell>
                            <Table.HeaderCell>{locale.labels.endDate}</Table.HeaderCell>
                            <Table.HeaderCell>{locale.labels.remarks}</Table.HeaderCell>
                            <Table.HeaderCell>{locale.labels.alert}</Table.HeaderCell>
                            <Table.HeaderCell style={{ width: '80px' }}></Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          {auditFollowups.map(function(f, idx) {
                            var ft = followupTypes.find(function(t) { return (t.inS_FollowupTypeID || t.INS_FollowupTypeID) === f.INS_FollowupTypeID; });
                            return (
                              <Table.Row key={idx}>
                                <Table.Cell>{ft ? (ft.inS_FollowupTypeName || ft.INS_FollowupTypeName) : ' '}</Table.Cell>
                                <Table.Cell>{f.INS_MainAuditFollowupsStartDate || ' '}</Table.Cell>
                                <Table.Cell>{f.INS_MainAuditFollowupsEndDate || ' '}</Table.Cell>
                                <Table.Cell>{f.INS_MainAuditFollowupsRemarks || ' '}</Table.Cell>
                                <Table.Cell textAlign='center'>
                                  <Checkbox checked={f.INS_MainAuditFollowupsAlert || false} disabled />
                                </Table.Cell>
                                <Table.Cell textAlign='center'>
                                  <Button
                                    size='small'
                                    color='red'
                                    type="button"
                                    icon
                                    onClick={function() { onDeleteFollowup(idx); }}
                                  >
                                    <Icon name='trash' />
                                  </Button>
                                </Table.Cell>
                              </Table.Row>
                            );
                          })}
                        </Table.Body>
                      </Table>
                    )}
                  </Segment>
                )}

                <Segment>
                  <Header as='h3'>{locale.headers.fileUploads}</Header>

                  {[
                    { num: 1, label: locale.labels.upload1, ref: fileInputRef1, filename: form.INS_MainAuditUploadFilename1 },
                    { num: 2, label: locale.labels.upload2, ref: fileInputRef2, filename: form.INS_MainAuditUploadFilename2 },
                    { num: 3, label: locale.labels.upload3, ref: fileInputRef3, filename: form.INS_MainAuditUploadFilename3 },
                  ].map(function(upload) {
                    return (
                      <FileUploadContainer key={upload.num}>
                        <label>{upload.label}</label>
                        <div className="file-input-wrapper">
                          <input
                            ref={upload.ref}
                            type="file"
                            style={{ display: 'none' }}
                            onChange={function(e) { handleFileUpload(e, upload.num); }}
                          />
                          <Button
                            type="button"
                            size="small"
                            onClick={function() { upload.ref.current.click(); }}
                          >
                            <Icon name="upload" /> {locale.buttons.chooseFile}
                          </Button>
                          {upload.filename ? (
                            <React.Fragment>
                              <span className="file-name">
                                <Icon name="check" color="green" /> {upload.filename}
                              </span>
                              <Button
                                type="button"
                                size="small"
                                color="red"
                                onClick={function() { handleFileClear(upload.num); }}
                              >
                                <Icon name="times" /> {locale.buttons.cancelUpload}
                              </Button>
                            </React.Fragment>
                          ) : (
                            <span className="file-name-placeholder">{locale.labels.noFileChosen}</span>
                          )}
                        </div>
                      </FileUploadContainer>
                    );
                  })}
                </Segment>

                <Segment>
                  <Header as='h3'>{locale.headers.signatures}</Header>

                  <Form.Group widths='equal'>
                    <Form.Field>
                      <label>{locale.labels.managerSignature}</label>
                      <CardForSignature fluid>
                        <SignatureModal
                          report={report}
                          registerSignatrue={registerSignatrue}
                          saveSignatrues={saveSignatrues}
                          type="SSOSig"
                          color="red"
                        />
                      </CardForSignature>
                    </Form.Field>

                    <Form.Field>
                      <label>{locale.labels.employeeSignature}</label>
                      <CardForSignature fluid>
                        <SignatureModal
                          report={report}
                          registerSignatrue={registerSignatrue}
                          saveSignatrues={saveSignatrues}
                          type="EmpSig"
                          color="blue"
                        />
                      </CardForSignature>
                    </Form.Field>
                  </Form.Group>
                </Segment>

                <div style={{ marginTop: '1em', display: 'flex', gap: '1em' }}>
                  <Button
                    primary
                    onClick={handleSubmit}
                    disabled={saving}
                    loading={saving}
                  >
                    <Icon name='save' /> {locale.buttons.saveAudit}
                  </Button>
                  <Button
                    as={Link}
                    to="/audit"
                    disabled={saving}
                  >
                    <Icon name='cancel' /> {locale._system.cancel}
                  </Button>
                </div>
              </React.Fragment>
            )}
          </Form>
        </Card.Content>
      </Card>

      {/* Description Modal */}
      <Modal
        open={descriptionModal.open}
        onClose={function() { setDescriptionModal({ open: false, title: '', description: '' }); }}
        size='small'
      >
        <Modal.Header>
          <Icon name='question circle' /> {descriptionModal.title}
        </Modal.Header>
        <Modal.Content>
          <p>{descriptionModal.description || locale.messages.noDescriptionAvailable}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={function() { setDescriptionModal({ open: false, title: '', description: '' }); }}>
            <Icon name='close' /> {locale._system.close}
          </Button>
        </Modal.Actions>
      </Modal>

      {/* Remarks Modal */}
      <Modal
        open={remarksModal.open}
        onClose={function() { setRemarksModal({ open: false, kpiTypeId: null, value: '' }); }}
        size='small'
      >
        <Modal.Header>
          <Icon name='edit' /> {locale.modals.remarks.title}
        </Modal.Header>
        <Modal.Content>
          <Form>
            <TextArea
              value={remarksModal.value}
              onChange={function(e, data) { setRemarksModal(function(prev) { return Object.assign({}, prev, { value: data.value }); }); }}
              rows={5}
              placeholder={locale.placeholders.enterRemarks}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={function() { setRemarksModal({ open: false, kpiTypeId: null, value: '' }); }}>
            <Icon name='close' /> {locale._system.close}
          </Button>
          <Button primary onClick={saveRemarks}>
            <Icon name='save' /> {locale._system.save}
          </Button>
        </Modal.Actions>
      </Modal>

      {/* Follow-up Modal */}
      <Modal
        open={followupModal.open}
        onClose={function() { setFollowupModal({ open: false, kpiTypeId: null, value: '' }); }}
        size='small'
      >
        <Modal.Header>
          <Icon name='edit' /> {locale.modals.followup.title}
        </Modal.Header>
        <Modal.Content>
          <Form>
            <TextArea
              value={followupModal.value}
              onChange={function(e, data) { setFollowupModal(function(prev) { return Object.assign({}, prev, { value: data.value }); }); }}
              rows={5}
              placeholder={locale.placeholders.enterFollowup}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={function() { setFollowupModal({ open: false, kpiTypeId: null, value: '' }); }}>
            <Icon name='close' /> {locale._system.close}
          </Button>
          <Button primary onClick={saveFollowup}>
            <Icon name='save' /> {locale._system.save}
          </Button>
        </Modal.Actions>
      </Modal>

      {/* Follow-up Result Modal */}
      <Modal
        open={followupResultModal.open}
        onClose={function() { setFollowupResultModal({ open: false, kpiTypeId: null, value: '' }); }}
        size='small'
      >
        <Modal.Header>
          <Icon name='edit' /> {locale.modals.followupResult.title}
        </Modal.Header>
        <Modal.Content>
          <Form>
            <TextArea
              value={followupResultModal.value}
              onChange={function(e, data) { setFollowupResultModal(function(prev) { return Object.assign({}, prev, { value: data.value }); }); }}
              rows={5}
              placeholder={locale.placeholders.enterFollowupResult}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={function() { setFollowupResultModal({ open: false, kpiTypeId: null, value: '' }); }}>
            <Icon name='close' /> {locale._system.close}
          </Button>
          <Button primary onClick={saveFollowupResult}>
            <Icon name='save' /> {locale._system.save}
          </Button>
        </Modal.Actions>
      </Modal>

      {/* Employees Modal */}
      <Modal
        open={employeesModalOpen}
        onClose={function() { setEmployeesModalOpen(false); setExpandedPerson(null); setEmployeeSearch(''); }}
        size='large'
      >
        <Modal.Header>
          <Icon name='users' /> {locale.modals.employees.title}
        </Modal.Header>
        <Modal.Content scrolling>
          <Input
            icon='search'
            placeholder={locale.placeholders.searchEmployees}
            fluid
            value={employeeSearch}
            onChange={function(e, data) { setEmployeeSearch(data.value); }}
            style={{ marginBottom: '1em' }}
          />
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>{locale.labels.name}</Table.HeaderCell>
                <Table.HeaderCell style={{ width: '150px', whiteSpace: 'nowrap' }} textAlign='center'>{locale.labels.actions}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {(unitPersons || [])
                .filter(function(person) {
                  if (!employeeSearch) return true;
                  var fullName = ((person.rdS_Person_FirstName || person.RDS_Person_FirstName || '') + ' ' +
                    (person.rdS_Person_LastName || person.RDS_Person_LastName || '')).toLowerCase();
                  return fullName.indexOf(employeeSearch.toLowerCase()) !== -1;
                })
                .map(function(person) {
                  var personId = person.rdS_Person_ID || person.RDS_Person_ID;
                  var firstName = person.rdS_Person_FirstName || person.RDS_Person_FirstName || '';
                  var lastName = person.rdS_Person_LastName || person.RDS_Person_LastName || '';
                  var fullName = (firstName + ' ' + lastName).trim() + ' (' + personId + ')';
                  var isAdded = auditPersons.some(function(ap) { return ap.RDS_Person_ID === personId; });
                  var isExpanded = expandedPerson === personId;

                  return (
                    <React.Fragment key={personId}>
                      <Table.Row>
                        <Table.Cell>{fullName}</Table.Cell>
                        <Table.Cell textAlign='center'>
                          {isAdded ? (
                            <Button
                              size='small'
                              color='red'
                              type="button"
                              onClick={function() {
                                onDeleteAuditPerson(personId);
                                if (isExpanded) setExpandedPerson(null);
                              }}
                            >
                              <Icon name='trash' /> {locale.buttons.delete}
                            </Button>
                          ) : (
                            <Button
                              size='small'
                              color='green'
                              type="button"
                              onClick={function() {
                                setExpandedPerson(isExpanded ? null : personId);
                                setPersonForm({ taskTypeId: null, taskCategoryId: null, followupAlert: false, followupRemarks: '', followupResultDate: null });
                              }}
                            >
                              <Icon name='plus' /> {locale.buttons.add}
                            </Button>
                          )}
                        </Table.Cell>
                      </Table.Row>
                      {isExpanded && !isAdded && (
                        <Table.Row>
                          <Table.Cell colSpan={2}>
                            <Form>
                              <Form.Group widths='equal'>
                                <Form.Field>
                                  <label>{locale.labels.followupTaskType}</label>
                                  <Select
                                    placeholder={locale.placeholders.selectTaskType}
                                    options={trainingEventTypes.map(function(t) {
                                      return {
                                        key: t.id,
                                        value: t.id,
                                        text: t.name
                                      };
                                    })}
                                    value={personForm.taskTypeId}
                                    onChange={function(e, data) {
                                      setPersonForm(function(prev) { return Object.assign({}, prev, { taskTypeId: data.value, taskCategoryId: null }); });
                                      onPersonTaskTypeChange(data.value);
                                    }}
                                    clearable
                                  />
                                </Form.Field>
                                <Form.Field>
                                  <label>{locale.labels.followupTaskSubject}</label>
                                  <Select
                                    placeholder={locale.placeholders.selectTaskSubject}
                                    options={trainingEventCategories.map(function(c) {
                                      return {
                                        key: c.id,
                                        value: c.id,
                                        text: c.name
                                      };
                                    })}
                                    value={personForm.taskCategoryId}
                                    onChange={function(e, data) { setPersonForm(function(prev) { return Object.assign({}, prev, { taskCategoryId: data.value }); }); }}
                                    disabled={!personForm.taskTypeId}
                                    clearable
                                  />
                                </Form.Field>
                                <Form.Field>
                                  <label>{locale.labels.followupResultDate}</label>
                                  <ReactDatePicker
                                    selected={personForm.followupResultDate}
                                    onChange={function(date) { setPersonForm(function(prev) { return Object.assign({}, prev, { followupResultDate: date }); }); }}
                                    dateFormat="dd/MM/yyyy"
                                    isClearable
                                    placeholderText={locale.placeholders.selectDate}
                                  />
                                </Form.Field>
                                <Form.Field>
                                  <label>{locale.labels.followupAlert}</label>
                                  <Checkbox
                                    checked={personForm.followupAlert}
                                    onChange={function(e, data) { setPersonForm(function(prev) { return Object.assign({}, prev, { followupAlert: data.checked }); }); }}
                                  />
                                </Form.Field>
                              </Form.Group>
                              <Form.Field>
                                <label>{locale.labels.remarks}</label>
                                <TextArea
                                  value={personForm.followupRemarks}
                                  onChange={function(e, data) { setPersonForm(function(prev) { return Object.assign({}, prev, { followupRemarks: data.value }); }); }}
                                  rows={3}
                                  placeholder={locale.placeholders.enterRemarks}
                                />
                              </Form.Field>
                              <Button
                                primary
                                size='small'
                                type="button"
                                onClick={function() {
                                  onAddAuditPerson(personId, personForm.followupAlert, personForm.followupRemarks, personForm.followupResultDate, personForm.taskCategoryId);
                                  setExpandedPerson(null);
                                  setPersonForm({ taskTypeId: null, taskCategoryId: null, followupAlert: false, followupRemarks: '', followupResultDate: null });
                                }}
                              >
                                <Icon name='check' /> {locale.buttons.confirm}
                              </Button>
                              <Button
                                size='small'
                                type="button"
                                onClick={function() { setExpandedPerson(null); }}
                              >
                                {locale._system.cancel}
                              </Button>
                            </Form>
                          </Table.Cell>
                        </Table.Row>
                      )}
                    </React.Fragment>
                  );
                })}
            </Table.Body>
          </Table>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={function() { setEmployeesModalOpen(false); setExpandedPerson(null); setEmployeeSearch(''); }}>
            <Icon name='close' /> {locale._system.close}
          </Button>
        </Modal.Actions>
      </Modal>
    </Card.Group>
  );
};

export default compose(
  hot(module),
  withReportSignatures
)(AuditFormComponent);
